import { jsx as _jsx } from "react/jsx-runtime";
import { CircularProgress } from '@mui/material';
import { Img as ReactImage } from 'react-image';
import { ImageContainerShape } from './ImageOptions.js';
export function loadAndRenderImage(imageUrls, options, key) {
    let borderRadius = 0;
    const minImageDimensionInPixels = getMinImageDimensionInPixels(options.maxHeightInPixels, options.maxWidthInPixels);
    switch (options.containerShape) {
        case ImageContainerShape.RoundedRectangle:
            borderRadius = minImageDimensionInPixels / 20;
            break;
        case ImageContainerShape.Circle:
            borderRadius = minImageDimensionInPixels;
            break;
        default:
            break;
    }
    return (_jsx(ReactImage, { src: imageUrls, loader: renderLoadingPlaceholder(options.maxHeightInPixels, options.maxWidthInPixels), style: {
            borderRadius,
            maxHeight: options.maxHeightInPixels ?? '100%',
            maxWidth: options.maxWidthInPixels ?? '100%',
            backgroundColor: options.backgroundColor,
        } }, key));
}
function renderLoadingPlaceholder(maxHeightInPixels, maxWidthInPixels) {
    return (_jsx("div", { style: {
            minWidth: maxWidthInPixels,
            minHeight: maxHeightInPixels,
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
        }, children: _jsx(CircularProgress, { color: "primary" }) }));
}
export function getMinImageDimensionInPixels(maxHeightInPixels, maxWidthInPixels) {
    if (maxHeightInPixels === undefined && maxWidthInPixels === undefined) {
        throw new Error('Both dimensions were undefined. Must specify at least one min dimension.');
    }
    if (maxHeightInPixels === undefined) {
        return maxWidthInPixels;
    }
    if (maxWidthInPixels === undefined) {
        return maxHeightInPixels;
    }
    return Math.min(maxHeightInPixels, maxWidthInPixels);
}
export function getMaxImageDimensionInPixels(maxHeightInPixels, maxWidthInPixels) {
    if (maxHeightInPixels === undefined && maxWidthInPixels === undefined) {
        return undefined;
    }
    if (maxHeightInPixels === undefined) {
        return maxWidthInPixels;
    }
    if (maxWidthInPixels === undefined) {
        return maxHeightInPixels;
    }
    return Math.max(maxHeightInPixels, maxWidthInPixels);
}
//# sourceMappingURL=ImageUtilities.js.map